<template>
    <div class="date_wrap">
        <button class="btn btn_xs ico btn_lgray_line" @click="action_BeforeMonth"><v-icon>mdi-chevron-left</v-icon></button>
        <b>{{ dateString }}</b>
        <button class="btn btn_xs ico btn_lgray_line mgr_5" @click="action_NextMonth"><v-icon>mdi-chevron-right</v-icon></button>
    </div>
</template>

<script>
export default {
    props: {
        dateString: String,
        action_BeforeMonth: Function,
        action_NextMonth: Function
    }
}
</script>

<style lang="scss" scoped></style>
